import { render, staticRenderFns } from "./dev-drawer.vue?vue&type=template&id=f13f83e6&scoped=true"
import script from "./dev-drawer.vue?vue&type=script&lang=js"
export * from "./dev-drawer.vue?vue&type=script&lang=js"
import style0 from "./dev-drawer.vue?vue&type=style&index=0&id=f13f83e6&prod&lang=less&scoped=true"
import style1 from "./dev-drawer.vue?vue&type=style&index=1&id=f13f83e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_vue-template_ptp2uvm53q35aphlzqn6rhtzgm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13f83e6",
  null
  
)

export default component.exports